module.exports = __webpack_public_path__ + "img/trainOld.a8242252.png";